import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CustomerStatusRes;
export const CustomerStatusTodo = createAsyncThunk('CustomerStatus', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "Put",
            url: process.env.REACT_APP_API_URL + `update_customer_status/${data.id}`,
            data:{
                "customer_status" : data.status
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return CustomerStatusRes = res.data

    } catch (error) {
        return CustomerStatusRes = error.response.data
    }
})
